import { AbstractCommand } from 'src/models/command';

type SnoozeOption =
	| 'snooze_1_day'
	| 'snooze_1_hour'
	| 'snooze_2_hour'
	| 'snooze_4_hour'
	| 'snooze_5_min'
	| 'snooze_15_min'
	| 'snooze_30_min'
	| 'snooze_ok';

class DelayTheAlarmCommand extends AbstractCommand {
	readonly name = 'IFS_Alarm_Command_Command_DelayTheAlarmCommand';
	apiVersion = 2;

	public constructor(type: string, id: number, delayDuration: SnoozeOption) {
		super();
		this.parameters = {
			delayDuration: delayDuration,
			id: id,
			type: type,
		};
	}
}

export { DelayTheAlarmCommand, SnoozeOption };
